/* template */
<template minapp="mpx" xlang="wxml"><div class="card-main"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/KhrdC7PyHO1643101554521.png" class="auth-icon"/><div class="title">申请获得以下权限：</div><div class="content">获得您的身份信息(姓名、身份证号)</div><div class="content">滴滴企业版承诺本次获取权限将完全用于预订火车票,不会进行泄露与其他利用</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mc9661104"}'>
  @import '~@/mixins/stylus/color.styl'

  .card-main
    display flex
    flex-direction column
  .title
    font-size 14px
    color $train-color-333
    font-family PingFangSC
    font-weight bold
    text-align start
  .content
    font-size 12px
    color $train-color-666
    font-family PingFangSC
    text-align start
  .auth-icon
    height 24px
    width 120px
    align-self center
    box-sizing border-box
    margin-bottom 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc9661104"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./id-authorize.mpx.js?isComponent&outputPath=components%2Fid-authorizec9661104%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./id-authorize.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fid-authorizec9661104%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc9661104"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/id-authorizec9661104/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
